const authorizedScheduledOffersUsers = [
  'dana@foodforjoe.es',
  'data@foodforjoe.com',
  'adriana.molvinger@foodforjoe.es',
  'albane@foodforjoe.es',
  'daniel.garrido@foodforjoe.es',
  'paolo.troni@foodforjoe.es',
  'diego@foodforjoe.es',
];

export default authorizedScheduledOffersUsers;
